import { FeatureToggleService } from '../services/FeatureToggleService'
import { Filter } from './LobbyFilters'
import { FilterOption } from '../ui/lobby/menu/filter/FilterComponent'
import { GameObject } from './MenuFilters'
import { ClientConfig } from '../config/ClientConfig'

export class StaffOnlyTableFilter extends Filter {
	private readonly userId: number

	constructor(userId: number) {
		super()
		this.userId = userId
	}

	updateFilter(filterOptions: FilterOption<any>[]) {
		super.updateFilter(filterOptions)
	}

	filter(game: GameObject): boolean {
		return game.name.indexOf(ClientConfig.BBJ_FEATURE.staffRingGamePrefix) === 0
			? FeatureToggleService.bbjFeature.isStaff(this.userId)
			: true
	}
}
